<!-- Header -->
<ibero-header></ibero-header>

<!-- Carrusel -->
<ibero-carrusel [gsid]="gsid()"></ibero-carrusel>

<!-- Error notification -->
@if (error()) {
    <div class="error-notification">
        <p class="error-message">{{ error() }}</p>
        <button (click)="clearError()" class="btn-dismiss">Cerrar</button>
    </div>
}

<!-- Main content -->
<main>
    <!-- Loading state -->
    @if (isLoading()) {
        <div class="loading-container">
            <div class="spinner"></div>
            <p>Cargando servicios...</p>
        </div>
    }

    <!-- Services grid -->
    @if (!isLoading() && hasServices()) {
        @for (service of filteredServices(); track service.id) {
            <button 
                class="borders service-button" 
                (click)="handleNavigation(service, email())"
                [attr.aria-label]="'Abrir ' + service.name">
                <img 
                    [src]="service.icon" 
                    [alt]="service.name" 
                    height="40" 
                    width="40"
                    loading="lazy"/>
                <span class="title-service">{{ service.name }}</span>
            </button>
        }
    }

    <!-- Empty state -->
    @if (!isLoading() && !hasServices() && !error()) {
        <div class="empty-state">
            <p>No hay servicios disponibles</p>
            <button (click)="retryLoadServices()" class="btn-retry">Reintentar</button>
        </div>
    }

    <!-- WebView for Ibero -->
    @if (isIberoView()) {
        <app-web-view 
            [iberoViewUrl]="iberoViewUrl()" 
            (closeIframeEvent)="closeIframe()">
        </app-web-view>
    }
</main>

<!-- Footer -->
<ibero-footer></ibero-footer>